import { createAsyncThunk } from "@reduxjs/toolkit";
import { getProductsForMT, getStoreListForMT } from "src/api/bi";
import {
  getProductPricing,
  getReceiveDetails,
  postManualTransferPO
} from "src/api/sp";

export const ManualTransferPO = createAsyncThunk(
  "ManualTransferPO",
  (manualTransferPayload: any) => postManualTransferPO(manualTransferPayload)
);

export const searchProductsforMT = createAsyncThunk(
  "searchProductsforMT",
  ({
    searchQuery,
    storeId,
    signal,
    recevingStoreId
  }: {
    searchQuery: string;
    storeId: string;
    recevingStoreId: string;
    signal?: AbortSignal;
  }) => getProductsForMT(searchQuery, storeId, recevingStoreId, signal)
);

export const fetchStoreListForMT = createAsyncThunk("fetchStoreListForMT", () =>
  getStoreListForMT()
);

export const fetchTransferDetails = createAsyncThunk(
  "fetchTransferDetails",
  (payload: any) =>
    getReceiveDetails(
      payload.referenceId,
      payload.type,
      payload.docId,
      payload.storeId
    )
);

export const fetchProductPricingForPoItem = createAsyncThunk(
  "fetchProductPricingForPoItem",
  async (
    {
      uniqueId,
      storeId,
      itemId
    }: {
      uniqueId: string;
      storeId: string;
      itemId: string | number;
    },
    { signal }
  ) => {
    const { data } = await getProductPricing({ storeId, itemId, signal });
    return {
      uniqueId,
      retail: data?.retail,
      cost: data?.cost
    };
  }
);
